var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-licitaciones-configuracion-etiquetas"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('listado-etiquetas',{attrs:{"modulo":"licitaciones"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }